<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="client">Клиент</label>
    <input
      type="text"
      class="form-control"
      id="client"
      placeholder="Введите ID клиента"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'client-field',
  props: {
    value: [String, Number],
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Client.vue?50bce04a